import * as keywordsActions from './actions';
import keywordsEpics from './epics';
import reducer from './reducers';
import * as keywordsSelectors from './selectors';
import * as keywordsTypes from './types';

export { keywordsSelectors, keywordsEpics, keywordsActions, keywordsTypes };

export default reducer;
